import Config from 'conf';
import bindSocketEvents from './binds';

export default socketMiddleware => {
    bindSocketEvents(socketMiddleware);
    let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    let socketOn = socketMiddleware.socketOn.bind(socketMiddleware);
    return {
        inelioGetAllParams: function({ product_identifier, code, fheCenter_mac }) {
            const slaveCode = code.slice(0, 2);
            return new Promise((resolve, reject) => {
                let feedbackFunc = args => {
                    if (fheCenter_mac === args.fheCenter_mac && product_identifier === args.product_identifier && slaveCode === args.slave) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('inelioSlaveAllParams', feedbackFunc);
                        return resolve(args.params);
                    }
                    return reject(new Error('wrong product_identifier or slave code'));
                };
                socketOn('inelioSlaveAllParams', feedbackFunc);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('inelioSlaveAllParams', feedbackFunc);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('inelioGetAllParams', { product_identifier, code, fheCenter_mac });
            });
        },
        inelioSetParam: function({ product_identifier, code, param, value, fheCenter_mac }) {
            const slaveCode = code.slice(0, 2);
            return new Promise((resolve, reject) => {
                let feedbackFunc = args => {
                    if (fheCenter_mac === args.fheCenter_mac && product_identifier === args.product_identifier && slaveCode === String(args.slave)) {
                        if (timeoutFeedback) {
                            clearTimeout(timeoutFeedback);
                            timeoutFeedback = null;
                        }
                        socketMiddleware.off('inelioSlaveParamFeedback', feedbackFunc);
                        return;
                    }
                    return reject(new Error('feedback_error'));
                };
                socketOn('inelioSlaveParamFeedback', feedbackFunc);
                let timeoutFeedback = setTimeout(function() {
                    timeoutFeedback = null;
                    socketMiddleware.off('inelioSlaveParamFeedback', feedbackFunc);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                let changeFunc = args => {
                    if (fheCenter_mac === args.fheCenter_mac && product_identifier === args.product_identifier && slaveCode === String(args.slave)) {
                        if (timeoutChange) {
                            clearTimeout(timeoutChange);
                            timeoutChange = null;
                        }
                        socketMiddleware.off('inelioSlaveParam', changeFunc);
                        return resolve(args);
                    }
                    return reject(new Error('change_error'));
                };
                socketOn('inelioSlaveParam', changeFunc);
                let timeoutChange = setTimeout(function() {
                    timeoutChange = null;
                    socketMiddleware.off('inelioSlaveParam', changeFunc);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('inelioSetParam', { product_identifier, code, param, value, fheCenter_mac });
            });
        },
        inelioSetDiagMode: function({ product_identifier, code, fheCenter_mac, mode }) {
            const slaveCode = code.slice(0, 2);
            return new Promise((resolve, reject) => {
                let feedbackFunc = args => {
                    if (fheCenter_mac === args.fheCenter_mac && product_identifier === args.product_identifier && slaveCode === args.slave) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('inelioDiagMode', feedbackFunc);
                        if (mode !== args.mode) return reject(new Error(`mode has not been changed correctly, mode: ${args.mode}`));
                        return resolve(args.params);
                    }
                    return reject(new Error('wrong product_identifier or slave code'));
                };
                socketOn('inelioDiagMode', feedbackFunc);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('inelioDiagMode', feedbackFunc);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('inelioSetDiagMode', { product_identifier, code, fheCenter_mac, mode });
            });
        },
        inelioClearAlarm: function(payload) {
            return new Promise(resolve => {
                socketEmit('inelioAlarmACK', payload);
                resolve();
            });
        },
        inelioSetSlaveActuator: function(payload) {
            return new Promise(resolve => {
                socketEmit('inelioSetSlaveActuator', payload);
                resolve();
            });
        },
        inelioSetStageActuator: function(payload) {
            return new Promise(resolve => {
                socketEmit('inelioSetStageActuator', payload);
                resolve();
            });
        },
        productCheckStatus: function(fheCenter_mac, product_type, product_identifier, module_type) {
            return new Promise((resolve, reject) => {
                let productCheckStatusFeedback = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        product_type === args.product_type &&
                        product_identifier === args.product_identifier &&
                        module_type === args.module_type
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('productStatus', productCheckStatusFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('productStatus', productCheckStatusFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('productCheckStatusFeedback', productCheckStatusFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('productCheckStatus', { fheCenter_mac, product_type, product_identifier, module_type });
            });
        },
        updateProductModuleLabel: function(fheCenter_mac, product_identifier, product_type, module_type, code, label) {
            return new Promise((resolve, reject) => {
                let updateProductModuleLabelFeedback = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        product_identifier === args.product_identifier &&
                        product_type === args.product_type &&
                        module_type === args.module_type &&
                        (product_type !== 'airzone' || code === args.code)
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('updateProductModuleLabelFeedback', updateProductModuleLabelFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('updateProductModuleLabelFeedback', updateProductModuleLabelFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('updateProductModuleLabelFeedback', updateProductModuleLabelFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('updateProductModuleLabel', { fheCenter_mac, product_identifier, product_type, module_type, code, label });
            });
        },
        getAPWifiProductsList: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let APWifiProductsList = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('APWifiProductsList', APWifiProductsList);
                        if (args.success) return resolve(args);
                        return reject(new Error(args.error));
                    }
                };
                socketOn('APWifiProductsList', APWifiProductsList);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('APWifiProductsList', APWifiProductsList);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('getAPWifiProductsList', { fheCenter_mac });
            });
        },
        connectToAP: function(fheCenter_mac, product_identifier) {
            return new Promise((resolve, reject) => {
                let connectToAPFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac && product_identifier === args.product_identifier) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('connectToAPFeedback', connectToAPFeedback);
                        if (args.success) return resolve(args);
                        return reject(new Error(args.error));
                    }
                };
                socketOn('connectToAPFeedback', connectToAPFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('connectToAPFeedback', connectToAPFeedback);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('connectToAP', { fheCenter_mac, product_identifier });
            });
        },
        getWifiList: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let wifiList = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('wifiList', wifiList);
                        if (args.success) return resolve(args);
                        return reject(new Error(args.error));
                    }
                };
                socketOn('wifiList', wifiList);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('wifiList', wifiList);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('getWifiList', { fheCenter_mac });
            });
        },
        startProductInclusion: function(fheCenter_mac, product_identifier, ssid, password, encryption, encryption_type, step_callback) {
            return new Promise((resolve, reject) => {
                let startProductInclusionFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac && product_identifier === args.product_identifier) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('startProductInclusionFeedback', startProductInclusionFeedback);
                        if (args.success) return args;
                        return reject(new Error(args.error));
                    }
                };
                let productInclusionStep = args => {
                    if (fheCenter_mac === args.fheCenter_mac && product_identifier === args.product_identifier) {
                        if (args.error) {
                            return reject(new Error(args.error));
                        }
                        if (typeof step_callback === 'function') {
                            return step_callback.call(this, args);
                        }
                        return args;
                    }
                };
                let productInclusion = args => {
                    if (fheCenter_mac === args.fheCenter_mac && product_identifier === args.product_identifier) {
                        socketMiddleware.off('productInclusionStep', productInclusionStep);
                        socketMiddleware.off('productInclusion', productInclusion);
                        if (args.success) return resolve(args);
                        return reject(new Error(args.error));
                    }
                };

                socketOn('startProductInclusionFeedback', startProductInclusionFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('startProductInclusionFeedback', startProductInclusionFeedback);
                    socketMiddleware.off('productInclusionStep', productInclusionStep);
                    socketMiddleware.off('productInclusion', productInclusion);
                    return reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketOn('productInclusionStep', productInclusionStep);
                socketOn('productInclusion', productInclusion);

                socketEmit('startProductInclusion', { fheCenter_mac, product_identifier, ssid, password, encryption, encryption_type });
            });
        },
        updateThreshold: function(fheCenter_mac, product_identifier, module_type, code, threshold) {
            return new Promise((resolve, reject) => {
                let updateFheProductThresholdFeedback = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        product_identifier === args.product_identifier &&
                        module_type === args.module_type &&
                        args.thresholds_config
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('updateFheProductThresholdFeedback', updateFheProductThresholdFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('updateFheProductThresholdFeedback', updateFheProductThresholdFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('updateFheProductThresholdFeedback', updateFheProductThresholdFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('updateFheProductThreshold', { fheCenter_mac, product_identifier, module_type, code, threshold });
            });
        },
        updateGain: function(fheCenter_mac, product_identifier, module_type, code, gain) {
            return new Promise((resolve, reject) => {
                let updateFheProductGainFeedback = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        product_identifier === args.product_identifier &&
                        module_type === args.module_type &&
                        args.gains_config
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('updateFheProductGainFeedback', updateFheProductGainFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('updateFheProductGainFeedback', updateFheProductGainFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('updateFheProductGainFeedback', updateFheProductGainFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('updateFheProductGain', { fheCenter_mac, product_identifier, module_type, code, gain });
            });
        },
        updatePolarity: function(fheCenter_mac, product_identifier, module_type, code, reversePolarity) {
            return new Promise((resolve, reject) => {
                let updateFheProductPolarityFeedback = args => {
                    if (
                        fheCenter_mac === args.fheCenter_mac &&
                        product_identifier === args.product_identifier &&
                        module_type === args.module_type &&
                        args.reverse_polarity_config
                    ) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('updateFheProductPolarityFeedback', updateFheProductPolarityFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('updateFheProductPolarityFeedback', updateFheProductPolarityFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('updateFheProductPolarityFeedback', updateFheProductPolarityFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('updateFheProductPolarity', { fheCenter_mac, product_identifier, module_type, code, reversePolarity });
            });
        },
        resetRelaysInversions: function(fheCenter_mac, product_identifier, module_type) {
            return new Promise((resolve, reject) => {
                let resetRelaysInversionsFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac && product_identifier === args.product_identifier) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('resetRelaysInversionsFeedback', resetRelaysInversionsFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('resetRelaysInversionsFeedback', resetRelaysInversionsFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('resetRelaysInversionsFeedback', resetRelaysInversionsFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('resetRelaysInversions', { fheCenter_mac, product_identifier, module_type });
            });
        },
        startMMBScan: function(product_identifier) {
            return new Promise((resolve, reject) => {
                let startMMBScanFeedback = args => {
                    if (product_identifier === args.product_identifier) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('startMMBScanFeedback', startMMBScanFeedback);
                        if (args.res === 'success') return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('startMMBScanFeedback', startMMBScanFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('startMMBScanFeedback', startMMBScanFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('startMMBScan', { product_identifier });
            });
        },
        updateSDM20LHTConfig: function(fheCenter_mac, product_identifier, typeDiversity, output) {
            return new Promise((resolve, reject) => {
                let setSDM20LHTConfigFeedback = args => {
                    if (args.product_identifier === product_identifier && args.fheCenter_mac === fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('setSDM20LHTConfigFeedback', setSDM20LHTConfigFeedback);
                        if (args.res === 'success') {
                            return resolve();
                        } else return reject(new Error('socket.error.setSDM20LHTConfig.fail'));
                    } else if (args.res === 'error') {
                        return reject(new Error(args.error));
                    } else return false;
                };
                socketOn('setSDM20LHTConfigFeedback', setSDM20LHTConfigFeedback);
                let timeout = setTimeout(() => {
                    socketMiddleware.off('setSDM20LHTConfigFeedback', setSDM20LHTConfigFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('setSDM20LHTConfig', {
                    fheCenter_mac,
                    product_identifier,
                    relay: typeDiversity,
                    output,
                });
            });
        },
    };
};



// WEBPACK FOOTER //
// ./environments/genericEnv/eventsSocket/Product/index.js